module.exports = "<div class=\"alert alert-danger\" *ngIf=\"errorMsg\">{{errorMsg}}</div>\r\n<div id=\"timeline\"\r\n  class=\"clearfix\"\r\n  *ngIf=\"timelineData\"\r\n  [chartData]=\"timelineData\"\r\n  [chartOptions] = \"timelineOptions\"\r\n  [selectionCallback] = \"selectionCallback\"\r\n  chartType=\"Timeline\"\r\n  GoogleChart></div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/collection-module/view/time-line/time-line.component.html
// module id = ../../../../../src/app/collection-module/view/time-line/time-line.component.html
// module chunks = main